/**
 * 액세스 토큰 보관소 — **메모리에만** 둔다.
 *
 * localStorage·sessionStorage 에 두면 XSS 한 번에 토큰이 통째로 새고, 탭이 닫힌 뒤에도
 * 디스크에 남는다. 리프레시 토큰이 httpOnly 쿠키로만 오가는 것과 같은 이유다 —
 * 서버도 액세스 토큰을 응답 본문으로만 내려보내며 그 규약을 전제한다
 * (`apps/api/src/modules/auth/social/social.controller.ts`).
 *
 * 새로고침하면 사라지는 것이 정상이다. 그때는 쿠키에 남은 리프레시 토큰으로
 * `auth.refresh` 를 한 번 불러 다시 받는다 (`session.ts`).
 */
let accessToken: string | null = null;

export const getAccessToken = (): string | null => accessToken;

/** null 을 넣으면 지운다 — 재발급 실패·로그아웃이 지나는 유일한 문. */
export const setAccessToken = (token: string | null): void => {
  accessToken = token;
};
